/**
 * Cookie-Helfer für Cross-Domain-Cookies (.kispro.de).
 * Wir setzen Theme/Sprache als Cookie, damit login.kispro.de und apirolf.kispro.de
 * dieselben Präferenzen sehen.
 */

const DOMAIN = '.kispro.de';

export function getCookie(name: string): string | null {
  const target = name + '=';
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const c = part.trim();
    if (c.startsWith(target)) return decodeURIComponent(c.slice(target.length));
  }
  return null;
}

export function setCookie(
  name: string,
  value: string,
  opts: { days?: number; sameSite?: 'Lax' | 'Strict' | 'None'; crossDomain?: boolean } = {},
): void {
  const { days = 365, sameSite = 'Lax', crossDomain = true } = opts;
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  const isLocalhost = typeof window !== 'undefined' && /localhost|127\.0\.0\.1/.test(window.location.hostname);
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    `expires=${expires}`,
    'path=/',
    `SameSite=${sameSite}`,
  ];
  if (crossDomain && !isLocalhost) parts.push(`domain=${DOMAIN}`);
  if (window.location.protocol === 'https:') parts.push('Secure');
  document.cookie = parts.join('; ');
}

export function deleteCookie(name: string, crossDomain = true): void {
  setCookie(name, '', { days: -1, crossDomain });
}
